import { render, staticRenderFns } from "./CustomerSettings.vue?vue&type=template&id=55126f02&scoped=true&"
import script from "./CustomerSettings.vue?vue&type=script&lang=js&"
export * from "./CustomerSettings.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=55126f02&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55126f02",
  null
  
)

export default component.exports